import { BaseResource } from './base';
import { Webhook, ListResponse, PaginationParams } from '../types';

export interface CreateWebhookData {
  url: string;
  events: string[];
  secret?: string;
}

export interface UpdateWebhookData extends Partial<CreateWebhookData> {
  status?: 'active' | 'inactive';
}

export interface WebhookFilters extends PaginationParams {
  status?: 'active' | 'inactive';
  event?: string;
}

export class WebhooksResource extends BaseResource {
  async list(filters?: WebhookFilters): Promise<ListResponse<Webhook>> {
    return this.requestGet<ListResponse<Webhook>>('/webhooks', filters);
  }

  async get(webhookId: string): Promise<Webhook> {
    return this.requestGet<Webhook>(`/webhooks/${webhookId}`);
  }

  async create(data: CreateWebhookData): Promise<Webhook> {
    return this.requestPost<Webhook>('/webhooks', data);
  }

  async update(webhookId: string, data: UpdateWebhookData): Promise<Webhook> {
    return this.requestPatch<Webhook>(`/webhooks/${webhookId}`, data);
  }

  async delete(webhookId: string): Promise<{ success: boolean; message: string }> {
    return this.requestDelete<{ success: boolean; message: string }>(`/webhooks/${webhookId}`);
  }

  async test(webhookId: string): Promise<{ success: boolean; response: any }> {
    return this.requestPost<{ success: boolean; response: any }>(`/webhooks/${webhookId}/test`, {});
  }

  async getLogs(
    webhookId: string,
    filters?: PaginationParams & { startDate?: string; endDate?: string; status?: 'success' | 'failed' }
  ): Promise<ListResponse<any>> {
    return this.requestGet<ListResponse<any>>(`/webhooks/${webhookId}/logs`, filters);
  }

  verifySignature(payload: string, signature: string, secret: string): boolean {
    const crypto = require('crypto');
    const expectedSignature = crypto
      .createHmac('sha256', secret)
      .update(payload)
      .digest('hex');

    return signature === `sha256=${expectedSignature}`;
  }
}
